import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a4afd00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-view" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  style: {"height":"auto"}
}
const _hoisted_5 = {
  key: 2,
  class: "options"
}
const _hoisted_6 = {
  class: "left-controls",
  style: {"width":"70%","display":"flex"}
}
const _hoisted_7 = {
  key: 0,
  class: "select"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Day", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Week", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Month", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "month-selection" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-angle-left",
  title: "Previous month"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-angle-right",
  title: "Next month"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "month-label ml-3" }
const _hoisted_18 = { class: "right-btn" }
const _hoisted_19 = { class: "full-calendar-view ma-4" }

export function render(_ctx, _cache) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!!_ctx.header)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.header), 1))
        : _createCommentVNode("", true),
      (_ctx.isPortalOffline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " You're offline - Calendar information is currently unavailable. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.viewSelector)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.calendarView) = $event)),
                      class: "month-dropdown"
                    }, _hoisted_11, 512), [
                      [_vModelSelect, _ctx.calendarView]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.todayButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-default ml-2 today-btn",
                    onClick: _cache[1] || (_cache[1] = $event => (_ctx.today()))
                  }, " Today "))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.prev())),
                  class: "btn-no-border"
                }, _hoisted_14),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.next())),
                  class: "btn-no-border"
                }, _hoisted_16),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentDateDisplay), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
            ])
          ]))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      _createVNode(_component_FullCalendar, {
        options: _ctx.calendarOptions,
        ref: "fullCalendar"
      }, null, 8, ["options"])
    ], 512), [
      [_vShow, !_ctx.isPortalOffline]
    ])
  ]))
}